import { Button } from "@mui/material";
import styled from "styled-components";

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const Container = styled.div`
  margin-top: 16px;
  padding: 22px 22px 0 22px;
`;

export const GradientButton = styled(Button).attrs({
  fullWidth: true,
})`
  background: #2d5bff !important;
  color: #ffffff !important;
  height: 50px;
  border-radius: 8px !important;
  font-family: "Inter" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  line-height: 150% !important;
  text-transform: none !important;
  :disabled {
    opacity: 0.6;
  }
`;
